import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  resolveHubForLegacySubTab,
  DOCUMENT_HUBS,
} from '@/pages/documents/shared/tab-resolver';

// Redirect compat: `/documents/$id?subTab=*` punta al detail del documento
// nell'hub corretto, preservando id e subTab.
export const Route = createFileRoute(
  '/protected/_layout/documents/_layout/$id'
)({
  beforeLoad: ({ search, params }) => {
    const targetHub =
      resolveHubForLegacySubTab(search.subTab ?? undefined) ??
      DOCUMENT_HUBS.invoices;
    // TanStack Router non riesce a inferire il tipo literale per path
    // composti dinamicamente (basePath + id) — il path è valido a runtime
    // perché ogni hub ha le proprie route `$id` registrate nel routeTree.
    throw redirect({
      to: `${targetHub.basePath}/${params.id}`,
      search,
    } as never);
  },
  component: () => null,
});
